export const isRealtor = (userOrProfession) => {
  const profession =
    typeof userOrProfession === "string"
      ? userOrProfession
      : userOrProfession?.profession;

  const normalized = String(profession || "").trim().toUpperCase();
  return normalized === "RE" || normalized === "REAL ESTATE";
};
